import React, { useEffect, useRef, useCallback } from "react"
import { Box, Flex, Heading, Modal, ModalContent, ModalBody, ModalOverlay, useDisclosure } from "@chakra-ui/react"
import { BreadCrumb } from "../../../components/commons/breadcrumb"
import { breadCrumbFMPSecondLevel, breadCrumbFirstLevel, headerFooterContentWidth, headerFooterMaxWidth } from "../../../common/commonConstants"
import { SubPage, SubPageContent } from "../../../components/SubPage"
import { scrollTo, useIsLoggedIn } from "../../../components/commons/utils"
import { Colors } from "../../../theme/colors"
import { FMPActionButtons } from "../common.fmp.components/FMPActionButtons"
import { ViewFireManagementPlanForm } from "./ViewFireManagementPlanForm.support"
import { ViewFireManagementPlanTable } from "./ViewFireManagementPlanTable.support"
import { useParams } from "react-router-dom"
import { Login } from "../../login/login"

interface ViewFireManagementPlanProps {
  fmpId?: number
}

export const ViewFireManagementPlan: React.FC<ViewFireManagementPlanProps> = (): JSX.Element => {
  const isLoggedIn = useIsLoggedIn()
  const { isOpen: isLoginOpen, onClose: onLoginClose, onOpen: onLoginOpen } = useDisclosure()

  useEffect(() => {
    scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (!isLoggedIn) {
      onLoginOpen()
    }
  }, [isLoggedIn, onLoginOpen])

  const { fmpid: fmpId } = useParams<{ fmpid: string }>()
  const tableRef = useRef<HTMLDivElement>(null)

  // Login success handler
  const handleLoginSuccess = useCallback((): void => {
    onLoginClose()
  }, [onLoginClose])

  // Login cancel handler
  const handleLoginCancel = useCallback((): void => {
    onLoginClose()
  }, [onLoginClose])

  return (
    <>
      <SubPage>
        <BreadCrumb
          options={{
            ...breadCrumbFirstLevel,
            ...breadCrumbFMPSecondLevel,
            thirdLevel: { title: "View FMP" }
          }}
        />

        <SubPageContent props={{ pt: "22px" }} innerBoxProps={{ w: headerFooterContentWidth, maxW: headerFooterMaxWidth }}>
          <Flex justifyContent="space-between" alignItems="center" w="100%" mb="3">
            <Heading variant={"RHeading1"} textAlign="left" color="primary">
              Fire Management Plan
            </Heading>
            <FMPActionButtons fmpId={Number(fmpId)} />
          </Flex>
          <Box height="1px" bg={Colors.Alternative["900"]} mb="4" />
          <ViewFireManagementPlanForm refToPass={tableRef} fmpId={Number(fmpId)} />
          <ViewFireManagementPlanTable refToPass={tableRef} fmpId={Number(fmpId)} />
        </SubPageContent>
      </SubPage>

      {/* Login Modal */}
      <Modal isOpen={isLoginOpen} onClose={onLoginClose} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalBody padding="0">
            <Login successCallBack={handleLoginSuccess} loginCancelCallBack={handleLoginCancel} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
